var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmariLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 234,
    viewBox: "0 0 240 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 117,
    rx: 120,
    ry: 117,
    fill: "#002772"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.5,
    cy: 117.5,
    rx: 114.5,
    ry: 110.5,
    fill: "#3296C0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 117.5,
    rx: 110,
    ry: 104.5,
    fill: "#002772"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 117.5,
    rx: 102,
    ry: 96.5,
    fill: "#3296C0"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.5,
    cy: 117.5,
    rx: 94.5,
    ry: 88.5,
    fill: "#002772"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.29,
    height: 94.4988,
    transform: "matrix(0.999767 -0.0215602 0.00667145 0.999978 142 68.1204)",
    fill: "#3296C0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.29,
    height: 41.3803,
    transform: "matrix(0.00681476 0.999977 -0.999757 0.0220231 183.963 156.604)",
    fill: "#3296C0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 52,
    width: 5,
    height: 130,
    fill: "#3296C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1459 68L80.8665 71.4805L47.673 159.475L41.7813 159.442L74.1459 68Z",
    fill: "#3296C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9771 122.843L62.6064 115.892L96.5812 115.394L99.9674 122.257L59.9771 122.843Z",
    fill: "#3296C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0199 71.597L80.6956 68L115.88 157.649L109.893 157.581L74.0199 71.597Z",
    fill: "#3296C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmariLogo);
export default __webpack_public_path__ + "static/media/Amari-logo.f2cfa3c342e3a43ba241220999aa6759.svg";
export { ForwardRef as ReactComponent };